// This class is a dummy one. We will call to this class if the chatbot is disabled by BE
class DummyChatbotService {
  isAvailable = () => {
    return true
  }

  initChatBot() {
    console.warn('Chatbot is disabled by BE. Calling initChatBot')
  }

  changeChatBotLanguage(language) {
    console.warn(
      'Chatbot is disabled by BE. Calling changeChatBotLanguage',
      language
    )
  }

  toggleChatBotIfNeeded() {
    console.warn('Chatbot is disabled by BE. Calling toggleChatBotIfNeeded')
  }

  setChatMetaFields() {
    console.warn('Chatbot is disabled by BE. Calling setChatMetaFields')
  }

  displayChatbot() {
    console.warn('Chatbot is disabled by BE. Calling displayChatbot')
  }

  hideChatbot() {
    console.warn('Chatbot is disabled by BE. Calling hideChatbot')
  }

  showChatbot() {
    console.warn('Chatbot is disabled by BE. Calling showChatbot')
  }

  async cleanup() {
    console.warn('Chatbot is disabled by BE. Calling cleanup')
  }
}

export default DummyChatbotService
